<script setup lang="ts">
import { computed, toRef } from "vue";
import AnalysisCardShell from "./AnalysisCardShell.vue";
import { useKpiData } from "@/composables/useKpiMetric";

const props = defineProps({
  card: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
});

const cardRef = toRef(props, "card");
const { metric, result, formatted, color, withWeights } = useKpiData(cardRef);

const options = computed(() => props.card.options || {});

const SIZE_CLASS = { s: "text-4xl", m: "text-6xl", l: "text-8xl" };
const sizeClass = computed(() => SIZE_CLASS[options.value.size] || SIZE_CLASS.m);

const isConfigured = computed(() => metric.value?.question_id != null);
</script>

<template>
  <AnalysisCardShell
    :card="card"
    :readonly="readonly"
    :weighted="isConfigured && withWeights"
    :state="isConfigured ? 'ready' : 'unconfigured'">
    <div class="mt-1">
      <span
        :class="sizeClass"
        class="font-semibold leading-none"
        :style="{ color }"
        :title="result && result.n != null ? `n = ${result.n}` : null">
        {{ formatted }}
      </span>
    </div>
  </AnalysisCardShell>
</template>
